import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, Tooltip} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'courseName', label: '课程名称'},
    {key:'courseNo', label: '课程代码'},
    {key:'orgName', label: '所属部门'},
    {key:'courseTypeName', label: '课程类别'},
    {
        key: 'targetNames',
        label: '课程指标',
        render: (d) => {
            return <Tooltip title={d} >{d}</Tooltip>
        }
    },
    {key:'courseDesc', label: '描述', width: 240}
]);

///platform/code//course/property

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByName = (keywords ={}) => {
    return fetch.post('course/find', keywords)
    .then(response => {
        var list = (response.payload.data || []).map(d => ({
            value: d.courseId+ "",
            label: d.courseName
        }));

        // if(keywords.courseName) {
        //     return [{label: keywords.courseName, value: ""}, ...list];
        // } else {
            return list;
        // }
    });
}

const getByCourseName = (keywords ={}) => {
    return fetch.post('course/getByCourseName', keywords)
    .then(response => {
        var list = (response.payload.data || []).map(d => ({
            value: d.courseId+ "",
            label: d.courseName
        }));

        if(keywords.courseName) {
            return [{label: keywords.courseName, value: ""}, ...list];
        } else {
            return list;
        }
    });
}

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByAddress = (keywords ={}) => {
    return fetch.post('course/plan/findAddressLookup', keywords)
    .then(response => {
        return (response.payload.data || []).filter(d =>{
            return d !== null;
        }).map(d => ({
            value: d.lessonAddress,
            label: d.lessonAddress
        }));
    });
}

const querySearchByCampus = (keywords ={}) => {
    return fetch.post('course/plan/findCampus', keywords)
    .then(response => {
        return (response.payload.data || []).filter(d =>{
            return d !== null;
        }).map(d => ({
            value: d.campus,
            label: d.campus
        }));
    });
}

const querySearchByAcademicBuilding = (keywords ={}) => {
    return fetch.post('course/plan/findAcademicBuilding', keywords)
    .then(response => {
        return (response.payload.data || []).filter(d =>{
            return d !== null;
        }).map(d => ({
            value: d.academicBuilding,
            label: d.academicBuilding
        }));
    });
}

const querySearchByFloor= (keywords ={}) => {
    return fetch.post('course/plan/findFloor', keywords)
    .then(response => {
        return (response.payload.data || []).filter(d =>{
            return d !== null;
        }).map(d => ({
            value: d.floor,
            label: d.floor
        }));
    });
}

/**
 * @method querySearchProperty
 * @param {object} keywords
 * @return {promise}
 */
const querySearchProperty = (keywords ={}) => {
    return fetch.post('/platform/code/course/property', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.codeValue,
            label: d.codeName
        }));
    });
}

/**
 * @method querySearchType
 * @param {object} keywords
 * @return {promise}
 */
const querySearchType = (keywords ={}) => {
    return fetch.post('/platform/code/course/type', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.codeValue,
            label: d.codeName
        }));
    });
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('course/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('course/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('course/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                okText:"确认",
                onOk() {
                    DataGrid.selections = [];
                },
            });
        }
        
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('course/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息',
                content: (
                    <div>
                    <p>{response.message}</p>
                    </div>
                ),
                okText:"确认",
                onOk() {
                    DataGrid.selections = [];
                },
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('course/remove/', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.refresh();
                            },
                        })
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
};

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'course'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能更新！',
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method querySearchType
 * @param {object} keywords
 * @return {promise}
 */
 const queryClassGradeType = (keywords ={}) => {
    return fetch.post('/platform/code/class/grade', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.codeValue,
            label: d.codeName
        }));
    });
}

const queryCourseTarget = (courseId) => {
    return fetch.get('course/queryCourseTarget/' + courseId)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    });
}

const setCourseTarget = (courseTargetId) => {
    return fetch.get('course/setCourseTarget/' + courseTargetId)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    });
}

const deleteCourseTarget = (courseTargetId) => {
    return fetch.get('course/deleteCourseTarget/' + courseTargetId)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    });
}


export default {
    insertURL: '#/course/insert',
    querySearchType,
    querySearchByName,
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getByCourseName,
    querySearchProperty,
    querySearchByAddress,
    getSelection,
    querySearchByCampus,
    querySearchByAcademicBuilding,
    querySearchByFloor,
    queryClassGradeType,
    queryCourseTarget,
    setCourseTarget,
    deleteCourseTarget
}